import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { BenefitXRefEntity } from "./benefitsxref.entity";
@Entity('100Benefits')

export class BenefitsEntity {  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("varchar",{
    nullable:true,
    length:1000,
    name:'Benefits'
  })
  benefits:string;

  @OneToMany(() => BenefitXRefEntity, (xrefdt: BenefitXRefEntity) => xrefdt.benefit)
  xrefdt: BenefitXRefEntity;

}


